import { render, staticRenderFns } from "./MenuCategoryAll.vue?vue&type=template&id=bb760bca&scoped=true&"
import script from "./MenuCategoryAll.vue?vue&type=script&lang=js&"
export * from "./MenuCategoryAll.vue?vue&type=script&lang=js&"
import style0 from "./MenuCategoryAll.vue?vue&type=style&index=0&id=bb760bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb760bca",
  null
  
)

export default component.exports